Application.Forms.FormControl = {
    ui: {
        container: '.form-control',
        input: '.form-control__input'
    },
    ready: function () {

        this.bind();

    },
    bind: function(){

        var self = this;

        $(document).on('focus', this.ui.input, function(){
            self.focus(this);
        });
        $(document).on('blur', this.ui.input, function(){
            self.blur(this);
        });
        
    },
    focus: function(input){

        $(input).closest(this.ui.container).addClass('form-control_active');

    },
    blur: function(input){

        $(input).closest(this.ui.container).removeClass('form-control_active');

    }
}